export type IntegratedPreviewShareSuccess = {
  success: true
  dogCardPath: string
  shareUrl?: string
  expiresAt?: string
  tokenDeliveredOnce: true
}

export type IntegratedPreviewShareFailure = {
  success: false
  error: {
    code: string
    message: string
  }
}

export type IntegratedPreviewShareResponse =
  | IntegratedPreviewShareSuccess
  | IntegratedPreviewShareFailure

export const INTEGRATED_PREVIEW_SHARE_USER_MESSAGE =
  "We couldn't create the Dog Card preview. Please try again."

export function integratedPreviewShareFailure(
  code: string,
  message: string = INTEGRATED_PREVIEW_SHARE_USER_MESSAGE,
  status: number
): { body: IntegratedPreviewShareFailure; status: number } {
  return {
    status,
    body: {
      success: false,
      error: { code, message },
    },
  }
}

export function integratedPreviewShareSuccess(
  dogCardPath: string,
  shareUrl: string,
  expiresAt: string
): IntegratedPreviewShareSuccess {
  return {
    success: true,
    dogCardPath,
    shareUrl,
    expiresAt,
    tokenDeliveredOnce: true,
  }
}
